
if(document.querySelector('[data-bar]')){
    new SimpleBar(document.querySelector('.bages__inner'));
}
if(document.querySelector('.tabs--scroll')){
    new SimpleBar(document.querySelector('.tabs--scroll'));
}

// if(document.querySelector('.catalog')){
//     const $catalogItemFooter = document.querySelectorAll('.catalog .product-footer');

//     $catalogItemFooter.forEach(el => {
//         el.addEventListener('mouseover', (e) => {
//             e.currentTarget.firstElementChild.classList.add('product-footer__name--active');
//             e.currentTarget.closest('.product__inner').classList.add('product-shadow');
//             // e.currentTarget.children.classList.add('product-footer__name--active');
            
//         })
//         el.addEventListener('mouseout', (e) => {
//             e.currentTarget.firstElementChild.classList.remove('product-footer__name--active');
//             e.currentTarget.closest('.product__inner').classList.remove('product-shadow');
            
//         })
//     })
// }


// const $moreCategoyBtn = document.querySelector('.category-btn');
// const $moreCategory = document.querySelector('.category__more');
// if($moreCategoyBtn){
//     $moreCategoyBtn.addEventListener('click', (e) => {
//         $moreCategory.classList.toggle('category__more--active');
//         if($moreCategory.classList.contains('category__more--active')){
//             e.currentTarget.textContent = 'Скрыть категории';
//         } else {
//             e.currentTarget.textContent = 'Показать все категории';
//         }
     
//     })
// }

/*SCROLL */
const scrollTo = (element) => {
	window.scroll({
		behavior: 'smooth',
		left: 0,
		top: element.offsetTop // - document.querySelector('.nav').clientHeight,
	});
}

if(document.querySelector('.pageup')){
  document.querySelector('.pageup').addEventListener('click', (e) => {
    e.preventDefault();
    scrollTo(document.querySelector('.page'))
   
  });
}
/*SCROLL */

$(document).ready(function(){
        $('.filter__item-drop').on('click', function(){
        
            $(this).toggleClass('filter__item-drop--active');
            $(this).next().slideToggle(200);
        });

        $('.footer-accordion').on('click', function(){
            $(this).toggleClass('footer-accordion--active');
            $(this).next().slideToggle(200);
        });

        $('.accordion').on('click', function(){
            $(this).toggleClass('accordion--active');
            $(this).next().slideToggle(300);
        });

        $('.table__collapse').on('click', function(){
            $(this).toggleClass('table__collapse--active')
            $(this).next().slideToggle(300);
        });

      

        $('.category-btn').on('click', function(){
            // $('.category__more').toggleClass('category__more--active');
            $('.category__more').slideToggle(200);
            $(this).toggleClass('active');
            if($(this).hasClass('active')){
                $(this).text('Скрыть категории');
            } else {
                $(this).text('Показать все категории');
            }

        });


        // Табы на JQuery
        // $('.tab').on('click', function(e) {
        //     e.preventDefault();
        //     $($(this).siblings()).removeClass('tab--active');
        //     $($(this).parent().siblings().find('.tabs-content')).removeClass('tabs-content--active');

        //     $(this).addClass('tab--active');
        //     $($(e.target).attr('href')).addClass('tabs-content--active');
              
        // });
         // /Табы на JQuery


});



    // if($('.slider-for').length>0)initSlickFor();
    // if($('.slider-nav').length>0)initSlickNav();

    // function initSlickFor() {
    //     $('.slider-for').slick({
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       arrows: false,
    //       fade: true,
    //       infinite: true,
    //       autoplay:true,
    //       asNavFor: '.slider-nav',
      
    //     });
    //   }

    // //   vertical: true,
    // //   verticalSwiping: true,
    // //   asNavFor: '.product-gallery-big',
    // //   // centerMode: true,
    // //   focusOnSelect: true,
    // //   infinite: false

    //   function initSlickNav() {
    //     $('.slider-nav').slick({
    //       slidesToShow: 4,
    //       slidesToScroll: 1,
    //       asNavFor: '.slider-for',
      
    //       focusOnSelect: true,
    //       centerMode: false,
    //       verticalSwiping: true,
    //       responsive: [
      
    //         {
    //           breakpoint:5000,
    //           settings: {
    //             vertical:true,
    //             infinite: true,
    //           }
    //         },
    //         {
    //           breakpoint: 991,
    //           settings: {
      
    //             vertical:false,
    //           }
    //         },
    //         {
    //           breakpoint: 767,
    //           settings: {
    //             slidesToShow: 3,
    //             vertical:false,
    //           }
    //         },
    //         {
    //           breakpoint: 600,
    //           settings: {
    //             slidesToShow: 2,
    //             vertical:false,
    //           }
    //         }
    //       ]
      
    //     });
    //     if($(".slider-nav .slick-track").children('div').length < 5){
    //         $(".slider-nav .slick-track").addClass('transform-stop');
    //       }
        
    //     }






